<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
          <app-back-button></app-back-button>
          <div class="page-header">
            <h1 class="page-title">¿Qué son los tokens?</h1>
            <p class="subtitle">Te contamos por qué existen, cómo cuidarlos y qué opciones tienes.</p>
          </div>

          <div class="glass-card hero-card">
            <div class="headline">Tus tokens de hoy</div>
            <div class="balance-row" *ngIf="tokens; else noTokens">
              <div class="balance">
                <span class="value">{{ tokens?.remaining }}</span>
                <span class="divider">/</span>
                <span class="value muted">{{ tokens?.allowance }}</span>
              </div>
              <div class="mini muted" *ngIf="tokens?.used">Usados hoy: {{ tokens?.used }}</div>
              <div class="mini muted">Se reinician cada día.</div>
            </div>
            <ng-template #noTokens>
              <div class="mini muted">No pudimos cargar tu saldo ahora mismo.</div>
            </ng-template>
          </div>

          <div class="info-grid">
            <div class="glass-card info-card">
              <div class="card-title">¿Por qué tokens?</div>
              <ul>
                <li>Limitamos las conversiones porque YouTube y Spotify nos establecen una cuota de uso diaria.</li>
                <li>Spotify → YouTube consume muchos tokens, especialmente si no se activa el modo ECO.</li>
                <li>YouTube → Spotify casi no gasta tokens.</li>
                <li>Limitamos tokens diariamente para que el servicio siga disponible y rápido.</li>
              </ul>
            </div>

            <div class="glass-card info-card">
              <div class="card-title">Cómo cuidarlos</div>
              <ul>
                <li>Modo <strong>ECO</strong>: sin búsquedas, gasta casi nada.</li>
                <li>Rematch cuesta tokens; úsalo solo donde lo necesites.</li>
                <li>Si no tienes saldo: usa ECO o espera al reset diario.</li>
              </ul>
              <div class="cta-buttons">
                <ion-button size="small" class="secondary-futuristic" (click)="goConvert()">
                  <span class="secondary-label">Probar en ECO</span>
                </ion-button>
              </div>
            </div>

            <div class="glass-card info-card">
              <div class="card-title">Premium</div>
              <ul>
                <li>Más tokens diarios y prioridad en colas.</li>
                <li>Mismo cuidado de cuota: hay límites razonables para no agotar la API.</li>
                <li>Si no quieres premium, usa ECO o espera al reset diario.</li>
              </ul>
              <ion-button size="small" class="futuristic-button" (click)="goAccount()">
                Upgrade to premium
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
